/* global grecaptcha */

import { useSelector, useDispatch } from 'react-redux';
import useUser from '../../../user';
import {
  RecaptchaVerifier,
  signInWithCredential,
  linkWithCredential
} from 'firebase/auth';
import { auth } from '../../../../firebase';
import { getStepFieldValue } from '../utils';
import { getFormValues } from '../utils';
import useParse from '../../../parse';
import { keyUpdatedAction } from '../../../../redux/actions/local';
import { PhoneAuthProvider } from 'firebase/auth';

/*
  Sends an SMS link to a phone number that the user can sign in with
*/
const useVerifyPhone = () => {
  const { accountExistsWithPhoneNumber, sendPhoneVerificationCode } = useUser();
  const user = useSelector(state => state.User);
  const { dataLinks } = useSelector(state => state.DataLinks);
  const { smsVerificationId } = useSelector(state => state.Local);
  const dispatch = useDispatch();
  const { parse } = useParse();

  const issueSMSCode = async ({
    step,
    history,
    documents,
    selections,
    local,
    data,
    params
    /*sequence,
    page*/
  }) => {
    let newData = {};

    if (data) {
      newData = { ...data };
    }

    if (step.formId?.trim().length > 0) {
      const inputs = getFormValues({
        formId: step.formId,
        returnObject: true
      });

      if (
        inputs !== undefined &&
        Object.keys(inputs).length > 0 &&
        step.formId?.trim().length > 0
      ) {
        newData = { ...inputs };
      }
    }

    step.fields?.forEach(stepField => {
      const stepFieldValue = getStepFieldValue({
        stepField,
        document,
        selections,
        documents,
        user,
        local,
        data: newData,
        dataLinks,
        params
      });
      if (stepField.dynamicFieldName?.trim().length > 0) {
        const targetField = parse({
          local,
          markup: stepField.dynamicFieldName,
          actionSequenceExecutionHistory: history,
          data,
          params
        });
        newData[targetField] = stepFieldValue;
      } else {
        newData[stepField.name] = stepFieldValue;
      }
    });

    const recaptchaVerifier = new RecaptchaVerifier(
      auth,
      'recaptcha-container',
      {
        size: 'invisible',
        callback: response => {
          //console.log('prepared phone auth process', response);
        }
      }
    );

    let phoneNumber = '';
    let phoneNumberWithoutCountryCode = '';
    if (newData.countryCode && newData.mobile) {
      phoneNumber = `${newData.countryCode}${newData.mobile}`.replace(/ /g, '');
      phoneNumberWithoutCountryCode = newData.mobile;
    } else if (user?.validUser && user.userID) {
      phoneNumber = `${user.countryCode}${user.mobile}`.replace(/ /g, '');
      phoneNumberWithoutCountryCode = user.mobile;
    }

    if (!phoneNumber?.length > 0) {
      return {
        error: true,
        message: `no phone number was supplied to the step. supply a form id, step fields or a current user`
      };
    }

    /*let result;

    if (user?.validUser && user.userID !== undefined) {
      // if we already have a user, link the phone number with the user
      result = await linkWithPhoneNumber(
        auth.currentUser,
        phoneNumber,
        recaptchaVerifier
      );
      dispatch(keyUpdatedAction('smsVerificationId', result.verificationId));
    } else {
      result = await sendPhoneVerificationCode(phoneNumber, recaptchaVerifier);
      dispatch(
        keyUpdatedAction(
          'smsVerificationId',
          result.confirmationResult.verificationId
        )
      );
    }*/

    try {
      const accountExists = await accountExistsWithPhoneNumber(
        phoneNumberWithoutCountryCode
      );

      if (accountExists) {
        return {
          error: true,
          message:
            'Sorry this phone number cannot be used with this service. Please provide a different phone number.'
        };
      }

      const result = await sendPhoneVerificationCode(
        phoneNumber,
        recaptchaVerifier
      );

      if (result?.confirmationResult?.verificationId) {
        dispatch(
          keyUpdatedAction(
            'smsVerificationId',
            result?.confirmationResult?.verificationId
          )
        );
      }

      if (result.error) {
        try {
          recaptchaVerifier.clear();
          grecaptcha.reset(recaptchaVerifier.widgetId);
        } catch {
          //na
        }

        return { error: true, message: result.message };
      }

      return result;
    } catch (error) {
      try {
        recaptchaVerifier.clear();
        grecaptcha.reset(recaptchaVerifier.widgetId);
      } catch {
        //na
      }
      return { error: true, message: error };
    }
  };

  const validateSMSCode = async ({
    step,
    history,
    documents,
    selections,
    local,
    data,
    params
    /*sequence,
    page*/
  }) => {
    let newData = {};

    if (data) {
      newData = { ...data };
    }

    if (step.formId?.trim().length > 0) {
      const inputs = getFormValues({
        formId: step.formId,
        returnObject: true
      });

      if (
        inputs !== undefined &&
        Object.keys(inputs).length > 0 &&
        step.formId?.trim().length > 0
      ) {
        newData = { ...inputs };
      }
    }

    step.fields?.forEach(stepField => {
      const stepFieldValue = getStepFieldValue({
        stepField,
        document,
        selections,
        documents,
        user,
        local,
        data: newData,
        dataLinks,
        params
      });
      if (stepField.dynamicFieldName?.trim().length > 0) {
        const targetField = parse({
          local,
          markup: stepField.dynamicFieldName,
          actionSequenceExecutionHistory: history,
          data,
          params
        });
        newData[targetField] = stepFieldValue;
      } else {
        newData[stepField.name] = stepFieldValue;
      }
    });

    if (!newData.verificationId && smsVerificationId) {
      newData.verificationId = smsVerificationId;
    }

    if (!newData?.verificationCode?.length > 0) {
      return {
        error: true,
        message: `No verificationCode was supplied to the step. supply a form id or a step field.`
      };
    } else if (!newData?.verificationId?.length > 0) {
      // the verificationId should come from the confirmation result when using issueSMSCode which puts it in the local redux store
      return {
        error: true,
        message: `No verificationId was supplied to the step. supply a form id or a step field.`
      };
    }

    var credential = PhoneAuthProvider.credential(
      newData.verificationId,
      newData.verificationCode
    );

    try {
      if (user?.validUser && user.userID !== undefined) {
        /*const linkResult = await linkWithCredential(
          auth.currentUser,
          credential
        );*/
        return await linkWithCredential(auth.currentUser, credential)
          .then(linkResult => {
            // link the phone number with the currently logged in user
            /*const linkCredential = PhoneAuthProvider.credentialFromResult(
              linkResult
            );*/
            //return linkResult;
            const signInResult = signInWithCredential(auth, credential);
            return {
              success: true,
              credential,
              linkResult,
              signInResult,
              message: `phone number ${user.countryCode}${user.mobile} linked to account with email ${user.email} for user id ${user.userID}`
            };
          })
          .then(signInResult => {
            //console.log('signInResult', signInResult);
            return signInResult;
          });
      } else {
        // we were not already signed in and therefore creating an account with a phone number
        return await signInWithCredential(auth, credential);
      }
    } catch (error) {
      return { error: true, message: error };
    }
  };

  return {
    validateSMSCode,
    issueSMSCode
  };
};

export default useVerifyPhone;
